import { Component, type ReactNode } from "react";

/**
 * A render error should not be a white screen. Without this, one bad row of
 * data takes the whole app down with nothing on screen and nothing to report.
 */
export class ErrorBoundary extends Component<
  { children: ReactNode },
  { error: Error | null }
> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: { componentStack?: string | null }) {
    console.error("render failed", error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="shell">
        <h1>Something broke</h1>
        <p className="muted">
          The page failed to render. This is a bug, not something you did.
        </p>
        <div className="panel">
          <pre className="trace-detail">{this.state.error.message}</pre>
          <button onClick={() => window.location.reload()}>Reload</button>{" "}
          <button className="quiet"
                  onClick={() => navigator.clipboard.writeText(
                    `${this.state.error?.message}\n\n${this.state.error?.stack ?? ""}`)}>
            Copy details
          </button>
        </div>
      </div>
    );
  }
}
